
const getDefault = function () {
    return {
        'user_id' : 0,
        'user_is_admin' : false,
        'is_dev_server' : true
    };
}

export default {
    getDefault
};
